export default __webpack_public_path__ + "static/media/whatsapp.0b02c96e.svg";